module.exports = __webpack_public_path__ + "img/tongyi-icon.6b342f32.png";